import fetch from 'isomorphic-fetch';
import { serviceroot } from '../config';
import Queue from 'promise-queue'
import Raven from 'raven-js';
var fetch_retry = require('fetch-retry')(fetch);
let queue = new Queue(1, 10);
let url = serviceroot + "api/CustomerPlan";

export const loadPlan = (id, securityToken) => {
    let request = {
        method: 'get',
        headers: {
            'Content-Type': 'application/json'
        }
    };
    let requesturl = url + "?id=" + id + "&securityToken=" + securityToken;
    return queue.add(() => fetch_retry(requesturl, request));
}

export const savePlan = (plan) => {
    let method;
    if (plan.Id)
        method = 'PUT';
    else
        method = 'POST';
    let request = {
        method: method,
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(plan)
    };
    let requesturl = url + ((plan.Id) ? ("/" + plan.Id + "?securityToken=" + plan.SecurityToken) : "");
    return queue.add(() => fetch_retry(requesturl, request).then((response) => {
        if (!response.ok) {
            throw Error(response.statusText);
        }
        if (method == 'POST') {
            return response.json().
                then((r) => {
                    return r;
                });
        }
        else
            return;
    }).
        catch((e) => {
            console.log("failed to fetch " + requesturl);
            Raven.captureException(e);
            throw e;
        }));
}


